module.exports = __webpack_public_path__ + "img/sfuel.0df58116.png";